// extracted by mini-css-extract-plugin
module.exports = {"attachment":"attachment__eNr9+","icon":"icon__C8XVk","action":"action__Xgp7I"};